<template>
  <div class="pane-content">
    <div class="panel discussion">
      <div class="panel-heading">
        <h3 class="heading -medium">Popular Topics</h3>
        <div class="select-style rtl">
          <form>
            <select v-model="timeRange" class="-maintain-size">
              <option value="today">Today</option>
              <option value="week">This Week</option>
              <option value="month">This Month</option>
            </select>
          </form>
        </div>
      </div>
      <div class="panel-body">
        <!-- hacky, comes from server side -->
        <slot v-if="timeRange === 'today'" name="today"></slot>
        <slot v-if="timeRange === 'week'" name="week"></slot>
        <slot v-if="timeRange === 'month'" name="month"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const timeRange = ref('today')
</script>
